import { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import { Folder } from '../types/GraphqlTypes';

/**
 * Maps GraphQL Folder enum to SatelliteConversationFolderTypeV2 (REST API enum).
 *
 * This mapping is needed during the React Query migration where:
 * - Conversation list uses REST API (SatelliteConversationFolderTypeV2)
 * - Other parts of the app still use GraphQL (Folder enum)
 *
 * This utility may become obsolete if the entire app migrates away from GraphQL.
 */
export const mapFolderToApiType = (folder: Folder): SatelliteConversationFolderTypeV2 => {
  switch (folder) {
    case Folder.Archived:
      return SatelliteConversationFolderTypeV2.ARCHIVED;
    case Folder.Inbox:
      return SatelliteConversationFolderTypeV2.INBOX;
    case Folder.Spam:
      return SatelliteConversationFolderTypeV2.SPAM;
    default:
      return SatelliteConversationFolderTypeV2.INBOX;
  }
};
